import React, { useState, useEffect } from "react";
import "../../css/Stats_New.css";
import { motion, animate } from "framer-motion";
import { FiUsers, FiAward, FiTrendingUp, FiCpu } from "react-icons/fi";

const Counter = ({ value, suffix = "+" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const controls = animate(0, value, {
      duration: 2.5,
      onUpdate: (latest) => setCount(Math.floor(latest)),
      ease: "easeOut"
    });
    return () => controls.stop();
  }, [value]);

  return <>{count.toLocaleString()}{suffix}</>;
};

export const Stats_New = () => {
  const stats = [
    { title: "Loan Disbursed", value: 8979, icon: <FiTrendingUp /> },
    { title: "Happy Users", value: 966, icon: <FiUsers /> },
    { title: "Skilled Experts", value: 375, icon: <FiCpu /> },
    { title: "Honorable Awards", value: 333, icon: <FiAward /> }
  ];

  return (
    <section className="stats_v8_wrapper">
      <div className="stats_v8_container">
        
        <motion.div 
          className="stats_v8_pill"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, type: "spring", stiffness: 80 }}
        >
          {stats.map((stat, index) => (
            <React.Fragment key={index}>
              <motion.div 
                className="stats_v8_item"
                whileHover={{ y: -5 }}
              >
                <div className="stats_v8_icon_box">
                  {stat.icon}
                </div>
                <div className="stats_v8_content">
                  <h3>
                    <Counter value={stat.value} />
                  </h3>
                  <p>{stat.title}</p>
                </div>
              </motion.div>
              
              {/* Add dividers between items, except the last one */}
              {index < stats.length - 1 && (
                <div className="stats_v8_divider"></div>
              )}
            </React.Fragment>
          ))}
        </motion.div>

      </div>
    </section>
  );
};
